import Vue from "vue";

export const mutations = {
  /**
   * Setting the favourite mode
   * @param {Object} state
   * @param {Boolean} value
   */
  setFavouriteMode(state, value) {
    state.favouriteMode = value === true;
  },
  /**
   * Add a person or other_event to loading list
   * @param {Object} state
   * @param {Int} value
   */
  addSendingFavRequest(state, value) {
    Vue.set(state.sendingFavRequest, value, true);
  },
  /**
   * Remove a person or other_event to loading list
   * @param {Object} state
   * @param {Int} value
   */
  removeSendingFavRequest(state, value) {
    Vue.set(state.sendingFavRequest, value, false);
  }
};
